module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("27VJ7"))).then(() => parcelRequire('ljYL6'));